import { Container } from 'reactstrap';
import styled from 'styled-components';

export const ServicesAndSidebarContainer = styled(Container)`
  margin-top: 50px;
  margin-bottom: 80px;
  @media(max-width: 991px) {
    margin-top: 15px;
    margin-bottom: 0;
  }
`;
